export const SERVER_ERROR_CODES = {
  common: 'common',
} as const;

export type ServerErrorCodes = (typeof SERVER_ERROR_CODES)[keyof typeof SERVER_ERROR_CODES];
